import React from 'react';
import PropTypes from 'prop-types';

/**
 * CustomHeaderRowRenderer Component in Table
 * @function CustomHeaderRowRenderer
 * @param {string} className -- className of input
 * @param {Object} columns -- array of objects representing column data
 * @param {Object} style -- wrapper div style
 * @return {ReactElement}
 */
const CustomHeaderRowRenderer = ({ className, columns, headerRowStyle = {}, style = {} }) => {
  const newStyle = { ...style, paddingRight: '9px', ...headerRowStyle };
  return (
    <div className={className} role="row" style={newStyle}>
      {columns}
    </div>
  );
};

CustomHeaderRowRenderer.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.func,
      ]),
    )
  ).isRequired,
  className: PropTypes.string,
  headerRowStyle: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  ),
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  ),
};

export default CustomHeaderRowRenderer;
